import { SearchButton } from './SearchButton'
import { useState } from 'react'
import { InputSearch } from './InputSearch'
import { useRecoilState } from 'recoil'
import { ImgNameSearch } from '../../../../state/atom'

import '../../style.css'
export function Serch(params: any) {
  const [Search, setSearch] = useState('hidden')
  const [text, setText] = useRecoilState(ImgNameSearch)

  return (
    <>
      <div className={`SearchItem ${Search}`}>
        <InputSearch testo={text} funcS={setText} funcB={setSearch} clas={Search} />
      </div>
      <SearchButton func={setSearch} />
    </>
  )
}
